import * as React from 'react'
const DownloadIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M15.5 17a.5.5 0 01.5.5.5.5 0 01-.41.49H4.5a.5.5 0 01-.09-1H15.5zM10 2a.5.5 0 01.49.41V14.3l3.64-3.65a.49.49 0 01.64-.06l.07.06a.5.5 0 01.06.63l-.06.07-4.49 4.5a.48.48 0 01-.26.14H10a.53.53 0 01-.4-.19l-4.46-4.45a.5.5 0 010-.7.49.49 0 01.64-.06l.07.06 3.65 3.64V2.5A.5.5 0 0110 2z" className="-secondary-color" fill="#d7dae0"/>
    </svg>
    
  )
}

export default DownloadIcon